import { NavItem, NavLink, Nav } from 'reactstrap';
import { useNavigate } from 'react-router-dom';

import styles from './menu.module.scss';

import menuList from '../../menu';

import { getUser } from "../../services/auth";

function Menu() {
  const user: any = getUser();
  const cidades = user?.cidades || [];
  const cidade = cidades.length > 0 ? cidades[0] : null;
  const cidadeMapa = cidade?.mapa_virtual || "";
  const censoUrl = cidade?.censo?.url || "";

  const navigate = useNavigate();

  const handleItemClick = (url: string) => {
    navigate(url);
  }

  return (
    <Nav className={`${styles.menu} nav justify-content-end`}>
      {menuList.map((item, index) => (
        <NavItem key={index}>
          <NavLink className={styles.menuLink} onClick={() => handleItemClick(item.url)}>
            {item.nome}
          </NavLink>
        </NavItem>
      ))}

      {cidadeMapa && (
        <NavItem>
          <NavLink
            className={styles.menuLink}
            href={cidadeMapa}
            target="_blank"
            rel="noopener noreferrer"
          >
            Mapa Virtual
          </NavLink>
        </NavItem>
      )}

      {censoUrl && (
        <NavItem>
          <NavLink
            className={styles.menuLink}
            href={censoUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            Censo 2024
          </NavLink>
        </NavItem>
      )}
    </Nav>
  );
}

export default Menu;
